import styled, { css } from 'styled-components'

export const Section = styled.div<{ $locked?: boolean }>(
  ({ theme, $locked }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['20']};
    background: ${$locked ? theme.colors.gray100 : 'transparent'};
    border-radius: ${theme.border.radius['8']};
    padding: ${theme.space['12']};
    margin: -${theme.space['12']};
    cursor: ${$locked ? 'not-allowed' : 'default'};
  `,
)
